import React from 'react'
import type { ReactNode } from 'react'

import { SpTitle } from './SpTitle'
import styles from './SpFrame.module.css'

type Props = {
  title: string
  children?: ReactNode
  dataDgId?: string
}

export const SpFrame = ({ title, children, dataDgId }: Props) => (
  <div className={styles.frame}>
    <SpTitle dataDgId={dataDgId}>{title}</SpTitle>
    {children}
  </div>
)
